import * as React from 'react';
import { RowItems } from '../../models/TableProps';
import { DocumentData } from '../../models/DocumentLibrary';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { Box, Button, Typography } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { useTranslation } from 'react-i18next';
import { formatBytes } from '../../utils/numberFormatter';
import useDocumentLibrary from '../../hooks/dokumentLibrary/useDocumentLibrary';

export const DocumentLibraryTableRow: React.FC<RowItems<DocumentData>> = (
    props
) => {
    const { row, index } = props;

    const { t } = useTranslation('documentLibrary');
    const labelId = `enhanced-table-checkbox-${index}`;
    const documentLibrary = useDocumentLibrary();

    const downloadFile = () => {
        documentLibrary.getFile(row.id).then((resp) => {
            const url = window.URL.createObjectURL(new Blob([resp]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', row.name);

            // Append to html link element page
            document.body.appendChild(link);

            // Start download
            link.click();

            // Clean up and remove the link
            link.parentNode.removeChild(link);
        });
    };

    return (
        <TableRow hover>
            <TableCell
                component="th"
                id={labelId}
                scope="row"
                sx={{ width: '25%' }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        maxInlineSize: '250px',
                        overflowWrap: 'anywhere',
                    }}
                >
                    <PictureAsPdfIcon />
                    <Typography sx={{ paddingLeft: '10px' }}>
                        {row.name}
                    </Typography>
                </Box>
            </TableCell>
            <TableCell sx={{ width: '60%' }}>
                <Typography>{row.description}</Typography>
            </TableCell>
            <TableCell sx={{ width: '5%' }}>
                <Typography>{row.last_modified}</Typography>
            </TableCell>
            <TableCell sx={{ width: '5%' }}>
                <Typography>{formatBytes(row.file_size)}</Typography>
            </TableCell>
            <TableCell sx={{ width: '5%' }}>
                <Button onClick={downloadFile}>
                    <FileDownloadIcon />
                </Button>
            </TableCell>
        </TableRow>
    );
};
